import OrderTypeEnum from "@/constants/enums/OrderTypeEnum";

/** The order types the filter offers as checkboxes. AUCTION is deliberately left out (see OrdersFilter). */
export const SELECTABLE_ORDER_TYPES = [OrderTypeEnum.BUY, OrderTypeEnum.SELL] as const;

/**
 * The order types to send to the backend. Nothing ticked and everything ticked both mean "don't
 * filter": sending [SELL, BUY] would still drop auction orders, which "nothing ticked" shows.
 */
export const effectiveOrderTypes = (orderTypes: number[] | null): number[] | null => {
  if (!orderTypes || orderTypes.length === 0) return null;
  const allSelected = SELECTABLE_ORDER_TYPES.every((type) => orderTypes.includes(type));
  return allSelected ? null : orderTypes;
};
